class window.Header
  constructor: ->
    @popupPageOpen = false # флаг показывающий состояние открытости меню
    @shiftHeight = 56
    @scroll_top = 0 # размер прокрутки документа
    @menuBlock = $('.header-menu__list')
    @menuLink = $('.header-menu__link-block') # блок со ссылкой в меню
    @headerMenuButton = $('.header__menu-button') # кнопка открытия меню
    @siteMapBlock = $('.header__site-map') # Скрытый блок с картой сайта
    @siteMenuCloseButton = $('.header-site-map__close') # Кнопка закрытия карты сайта
    @mainLink = $('.site-map__main-link') # Ссылка на основные разделы  в карте сайта
    @gosbarOpen = false
    @sitesListPageOpen = false
    @notificationOpen = false
    @browserDetect = new window.BrowserDetect()

    if (@browserDetect.browser != "Safari")
      @initMenuLinks()

    @initGosbar()
    @initSiteMapOpen()
    @initHeaderOnScroll()
    @initMobileMenuLinks()
    @initAsideMenu()


# Инициализация ссылок в основном меню
  initMenuLinks: ->
    self = this
    @menuBlock.hover ->
      window.shadingContent = [this, 'header']
      unless self.popupPageOpen
#        self.menuLink.addClass('header-menu__link--disable')
#        $(this).removeClass('header-menu__link--disable')
        window.shading.shadingActive(window.shadingContent)

    @menuBlock.mouseleave ->
      window.shadingContent = [this, 'header']
      unless self.popupPageOpen && self.notificationOpen == false
#        self.menuLink.removeClass('header-menu__link--disable')
        window.shading.shadingDisable(window.shadingContent)


    # затенение остального контента
    $('header').mouseenter ->
      $('.shading-block').addClass('shading-block--menu')


    $('header').mouseleave ->
      $('.shading-block').removeClass('shading-block--menu')



  initGosbar: ->
    self = this
    $('.gosbar__cabinet').click (event)->
      if $(event.target).closest('.gosbar__cabinet-menu').length
        return

      $(this).find('.gosbar__cabinet-menu').toggle()
      $(this).toggleClass('gosbar__cabinet--active')
      self.gosbarOpen = !self.gosbarOpen

    # Открытие уведомления
    $('.gosbar__notification-button').click (event)->
      window.shadingContent = ['.gosbar', this]
      if $(event.target).closest('.gosbar__notification').length
        return
      $(this).find('.gosbar__notification').toggle()
      $(this).toggleClass('gosbar__notification-button--active')
      $(this).removeClass('gosbar__notification-button--unread')
      window.shading.shadingActive(window.shadingContent)
      $('.shading-block--active').css('zIndex', 30);
      self.notificationOpen = !self.notificationOpen
      clickTime = new Date().getTime()
      document.cookie = 'notificationStatusUpdateTime='+clickTime+';path=/'

      $.ajax
        url: "/controllers/update_notification_cookie.php"
        data: {"notificationStatusUpdateTime": clickTime}
        method: "POST"
        dataType: "text"
        success: (data) ->
          # console.log(data)

      if !self.notificationOpen
        window.shading.shadingDisable(window.shadingContent)
        $('.shading-block--active').css('zIndex', '');

    $('body').click (event) ->
      if self.gosbarOpen
        if $(event.target).closest('.gosbar__cabinet').length
          return
        $('.gosbar__cabinet').find('.gosbar__cabinet-menu').toggle()
        $('.gosbar__cabinet').toggleClass('gosbar__cabinet--active')
        self.gosbarOpen = !self.gosbarOpen
        event.stopPropagation()

    # Закрытие уведомления при нажатии на основной контент страницы
    $('body').click (event) ->
      window.shadingContent = [this, '.gosbar']
      if self.notificationOpen
        if $(event.target).closest('.gosbar__notification-button').length
          return
        $('.gosbar__notification-button').find('.gosbar__notification').toggle()
        $('.gosbar__notification-button').toggleClass('gosbar__notification-button--active')
        self.notificationOpen = !self.notificationOpen
        window.shading.shadingDisable(window.shadingContent)
        $('.shading-block--active').css('zIndex', '');
        event.stopPropagation()


    $('.gosbar__sites-button').click (event) ->
      if window.newspopupObject.popupPageOpen && self.sitesListPageOpen
        event.preventDefault()
        window.newspopupObject.closePopup()
      else
        setTimeout(
          ->
            self.sitesListPageOpen = true
        , 500)


# Инициализация ссылок в карте сайта для мобильной версии
  initMobileMenuLinks: ->
    @mainLink.click (e)->
      if $(window).innerWidth() < 720
        e.preventDefault()
        $(this).parent('.site-map__links-block').find('.site-map__links').slideToggle()
        $(this).toggleClass('site-map__main-link--active')


# Инициализация открытия и закрытия карты сайта
  initSiteMapOpen: ->
    self = this
    @headerMenuButton.click ->

# манипуляции при открытии всплывающего окна, чтобы страница не прыгала

# При открытии карты сайта смещаем весь контент на верх на величину прокрутки экрана
# При закрытии карты сайта убираем смещение для контента, и возвращаем размер прокрутки экрана
      unless self.popupPageOpen
        self.siteMapOpen()
      else
        self.siteMapClose()


# Открытие/закрытие карты сайта
  siteMapOpen: ->
    self = this
    self.popupPageOpen = true

    unless window.currentScrollSetFlag
      window.currentScroll = window.pageYOffset
      window.currentScrollSetFlag = true

    window.searchObject.closeSearch()
    # закрытие всплывающего окна с каталогом сайтов
    if @sitesListPageOpen
      window.newspopupObject.closePopup()
      @sitesListPageOpen = false

    $('html').addClass('body-overflow')
    setTimeout(
      ->
        $('.b-page').addClass('b-page--hidden')
    , 100)
    self.menuLink.addClass('header-menu__link--disable')
    self.headerMenuButton.addClass('header__menu-button--active')
    self.siteMapBlock.slideDown()


  siteMapClose: ->
    self = this
    self.popupPageOpen = false
    $('html').removeClass('body-overflow')
    $('.b-page').removeClass('b-page--hidden')

    self.menuLink.removeClass('header-menu__link--disable')
    self.headerMenuButton.removeClass('header__menu-button--active')
    self.siteMapBlock.slideUp()
    if window.currentScrollSetFlag
      $(window).scrollTop(window.currentScroll)

    if self.popupPageOpen == false && window.searchObject.popupPageOpen == false
      window.currentScroll = 0
      window.currentScrollSetFlag = false


# инициализация минималистичной версии меню при прокрутке окна
  initHeaderOnScroll: ->
    self = this

    # Меняем величину сдвига в зависимости от ширины окна
    $(window).resize ->
    if (($(window).width() || $('.popup-overlay')) > '720')
      self.shiftHeight = 56
    else
      self.shiftHeight = 48

    # переключаем состояния header на обычных окнах при скроле + cкрываем уведомление
    $(window).scroll ->
      self.editHeaderPosition()


  editHeaderPosition: ->
    self = this
    if $(window).scrollTop() > $('.gosbar__wrapper').height() + $('.gosbar__notification-list').height()*0.8
      $('.gosbar__notification-button').find('.gosbar__notification').css('display','none')
      $('.gosbar__notification-button').removeClass('gosbar__notification-button--active')
      self.notificationOpen = false
      window.shading.shadingDisable(window.shadingContent)
      $('.shading-block--active').css('zIndex', '');

    unless self.popupPageOpen || window.searchObject.popupPageOpen || window.newspopupObject.popupPageOpen
      if $(window).scrollTop() > self.shiftHeight
        $('header').addClass('header--fixed')
        $('.gosbar').addClass('gosbar--scroll-state')
        $('.static-page').addClass('static-page--shift')
      else if $('.popup-overlay').scrollTop() <= self.shiftHeight || $('.popup-overlay').scrollTop() == undefined
        $('header').removeClass('header--fixed')
        $('.gosbar').removeClass('gosbar--scroll-state')
        $('.static-page').removeClass('static-page--shift')



# Инициализация бокового меню для внутренних страниц
  initAsideMenu: ->
    activeStructureBlock = '.menu-structure__main-link-block--active'
    structureBlock = $('.menu-structure')
    width_window = $(window).innerWidth();
    height_window = $(window).innerHeight();

    $($(activeStructureBlock).parent('.menu-structure__section').children('.menu-structure__links-list')).toggle() # открываем текущие активное меню при загрузки страницы

    # раскрытие структуры раздела
    $('.menu-structure__main-link-block').click (event) ->
      if (!$(event.target).closest('.menu-structure__main-link-block--active').length && !$(event.target).closest('.menu-structure__links-list').length)
        $(activeStructureBlock).parent('.menu-structure__section').find('.menu-structure__links-list').slideUp()
        $('.menu-structure__main-link-block').removeClass('menu-structure__main-link-block--active')

      $($(this).parent('.menu-structure__section').find('.menu-structure__links-list')[0]).slideToggle()
      $(this).toggleClass('menu-structure__main-link-block--active')

    # раскрытие меню в мобильной версии
    $('.menu-structure-button').click ->
      $(this).parent('.menu-structure-wrapper').find('.menu-structure').slideToggle()
      if $(this).hasClass('menu-structure-button--active') == false
        $(this).addClass('menu-structure-button--active');
      else
        $(this).removeClass('menu-structure-button--active');

    # управление отображением бокового меню
    $(window).resize ->
      if width_window != $(window).innerWidth() && height_window == $(window).innerHeight()
        if ($(window).width() >= '1073')
          structureBlock.css('display', 'block')
          $('.menu-structure-button').removeClass('menu-structure-button--active');
        else
          structureBlock.css('display', 'none')
      width_window = $(window).innerWidth();
      height_window = $(window).innerHeight();


// WEBPACK FOOTER //
// ./assets/javascripts/app/header.coffee